<table id="tabela-hist-declaracaoComp" class="table table-striped" *ngIf="histDeclaracaoComp.length > 0" aria-label="Declaração Completa">
  <thead>
  <tr>
    <th scope="col">Protocolo</th>
    <th scope="col">Data da solicitação</th>
    <th scope="col">Origem</th>
    <th scope="col">Status</th>
    <th scope="col">Baixar</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let declaracao of histDeclaracaoComp">
    <td class="cor" [ngClass]="{'active': declaracao.status == 'Em Andamento'}">{{ declaracao.protocol | naoinformado }}</td>
    <td>{{ declaracao.createDate | date:"dd/MM/yyyy" | naoinformado }}</td>
    <td>{{ declaracao.origin | naoinformado}}</td>
    <td>{{ declaracao.status | naoinformado}}</td>
    <td [hidden]="declaracao.status !== 'Finalizado'">
      <a (click)="baixarPdf(declaracao.orderId)"><img src="assets/icone-pdf.svg" alt="Baixar PDF"></a>
    </td>
  </tr>
</tbody>
</table>

<ng-template #modalErro let-modal>
  <div id="modal-erro-pdf" class="modal-header">
     <h4 class="modal-title" id="modal-basic-title">Erro</h4>
     <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-alert [titulo]="'Erro'" [tipo]="'danger'">
      <p>Não foi possivel baixar o PDF nesse momento!<br>
      </app-alert>

  </div>
</ng-template>

<div class="mensagem-hist-declaracaoComp" id="id-mensagem-hist-declaracaoComp" *ngIf="histDeclaracaoComp.length == 0">Nenhum histórico encontrado.</div>
